import React from "react";
import { TokenCell } from "./TokenCell";
import { domId } from "../../../util/helpers";

// Cells for a tokenized Case ID that also links to the case in question

export const OpsCaseLinkCell = ({ row, value }) =>
  value ? (
    <a data-testid={`case-${domId(value)}-link`} href={`/operations/cases/${value}`} target="_blank" rel="noopener noreferrer">
      <TokenCell row={row} value={value} />
    </a>
  ) : null;

export const CaseLinkCell = ({ row, value }) =>
  value ? (
    <a data-testid={`case-${domId(value)}-link`} href={`/cases/${value}`} target="_blank" rel="noopener noreferrer">
      <TokenCell row={row} value={value} />
    </a>
  ) : null;
